// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2ftti","col":"styles_col__2Ki3Q"};